import React from "react";
import { motion } from "framer-motion";
import { Mail, Linkedin, Instagram } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-[#030712] text-white py-14 sm:py-20 px-6 border-t border-white/5">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="grid gap-10 sm:gap-12 md:grid-cols-4 mb-12"
        >
          {/* Brand */}
          <div className="md:col-span-2">
            <button
              onClick={() => navigate("/")}
              className="flex items-center gap-3 mb-5 group"
            >
              <img
                src="/assets/images/graftcounter-logo.png"
                alt="Graft Counter"
                className="w-9 h-9 object-contain rounded-xl"
              />
              <span className="text-base font-semibold tracking-tight group-hover:text-white/80 transition-colors">
                Graft Counter
              </span>
            </button>

            <p className="text-slate-500 text-sm leading-relaxed max-w-sm mb-6">
              AI-powered verification and reporting for hair transplant
              procedures. Bringing objectivity and documentation to
              post-operative analysis.
            </p>

            <div className="space-y-2.5">
              <a
                href="mailto:info@graftcounter.app"
                className="flex items-center gap-3 text-slate-500 hover:text-white transition-colors text-sm"
              >
                <Mail size={13} className="flex-shrink-0" />
                info@graftcounter.app
              </a>
              <a
                href="https://www.linkedin.com/company/graft-counter"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-slate-500 hover:text-white transition-colors text-sm"
              >
                <Linkedin size={13} className="flex-shrink-0" />
                LinkedIn
              </a>
              <a
                href="https://www.instagram.com/graftcounter/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-slate-500 hover:text-white transition-colors text-sm"
              >
                <Instagram size={13} className="flex-shrink-0" />
                Instagram
              </a>
            </div>
          </div>

          {/* Product */}
          <div>
            <h3 className="text-sm font-semibold text-white/60 mb-4 tracking-tight">
              Product
            </h3>
            <ul className="space-y-3 text-slate-500 text-sm">
              <li>
                <button
                  onClick={() => navigate("/gc-about")}
                  className="hover:text-white transition-colors text-left"
                >
                  How It Works
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/gc-about")}
                  className="hover:text-white transition-colors text-left"
                >
                  Analysis & Reports
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/gc-about")}
                  className="hover:text-white transition-colors text-left"
                >
                  For Clinics
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/login-screen")}
                  className="hover:text-white transition-colors text-left"
                >
                  Sign In
                </button>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-white/60 mb-4 tracking-tight">
              Legal
            </h3>
            <ul className="space-y-3 text-slate-500 text-sm">
              <li>
                <button
                  onClick={() => navigate("/login-screen")}
                  className="hover:text-white transition-colors text-left"
                >
                  Terms of Service
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/login-screen")}
                  className="hover:text-white transition-colors text-left"
                >
                  Privacy Policy
                </button>
              </li>
              <li>
                <a
                  href="mailto:info@graftcounter.app"
                  className="hover:text-white transition-colors"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </motion.div>

        {/* Copyright */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.2 }}
          className="border-t border-white/5 pt-6"
        >
          <p className="text-slate-600 text-xs text-center">
            © {new Date().getFullYear()} Graft Counter. All rights reserved.
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
